import { ReturnTrackingTriggerKey } from "./advanced-flow/triggers";

export enum KlaviyoEventType {
  RETURN_TRACKING = "Return Tracking",
  RETURN_CREATED = "Return Created",
  RETURN_CREATED_ITEM = "Return Created Item",
  ORDER_TRACKING = "Order Tracking Update",
  ORDER_TRACKING_ITEM = "Order Tracking Update Item",
  PRODUCT_SAVED_TO_WISHLIST = "Product Saved to Wishlist",
  CUSTOMER_ACCOUNT_CREATED = "Customer Account Created",
  COVERAGE_INCENTIVE_CREDIT = "Coverage Incentive Credit",
}

export const DEFAULT_KLAVIYO_RETURN_TRACKING_TRIGGERS: ReturnTrackingTriggerKey[] =
  [
    ReturnTrackingTriggerKey.RETURN_APPROVED,
    ReturnTrackingTriggerKey.RETURN_PROCESSED,
    ReturnTrackingTriggerKey.RETURN_EXPIRED,
    ReturnTrackingTriggerKey.RETURN_REJECTED,
    ReturnTrackingTriggerKey.BOXLESS_RETURNS_RMA_CREATED,
    ReturnTrackingTriggerKey.RETURN_EXCHANGE_COMPLETED,
    ReturnTrackingTriggerKey.RETURN_SHIPMENT_REMINDER,
    ReturnTrackingTriggerKey.RETURN_IN_TRANSIT,
    ReturnTrackingTriggerKey.RETURN_DELIVERED,
    ReturnTrackingTriggerKey.STORE_CREDIT_CREATED,
  ];

type CustomerAccountsKlaviyoEventType =
  | KlaviyoEventType.PRODUCT_SAVED_TO_WISHLIST
  | KlaviyoEventType.CUSTOMER_ACCOUNT_CREATED;

export const isCustomerAccountsKlaviyoEventType = (
  eventType: KlaviyoEventType,
): eventType is CustomerAccountsKlaviyoEventType => {
  return (
    eventType === KlaviyoEventType.PRODUCT_SAVED_TO_WISHLIST ||
    eventType === KlaviyoEventType.CUSTOMER_ACCOUNT_CREATED
  );
};
